import React from 'react'
import HomeContent from '../components/organisms/home-content/home-content'
import ModalViewer from '../components/organisms/modal-viewer/modal-viewer'
import {title, description} from "../constants/activity-seo";
import SEO from "../shared/seo";

function IndexPage() {
  return (
    <>
      <SEO title={title} description={description}/>
      <ModalViewer />
      <HomeContent />
    </>
  )
}

export default IndexPage
